import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';

const DepartureTypeStep = ({ busy, types, onSelect }) => {
  return (
    <Stack gap={1.5} py={1}>
      {types.map(type => (
        <LoadingButton
          key={type.value}
          variant="contained"
          loading={busy}
          onClick={() => onSelect(type.value)}
          sx={{ minHeight: 48 }}
        >
          {type.label}
        </LoadingButton>
      ))}
    </Stack>
  );
};

export default DepartureTypeStep;
